import { DocumentCivilStatusBirthUploadCrumbs } from 'civil-status/constants/breadcrumb';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import FormDocumentBirthUploadNew from 'civil-status/components/upload-document-birth-form';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { DocumentBirthUploadFormVM } from 'civil-status/view-models/document-birth-form';
import { toast } from 'react-toastify';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { transformUploadBirthNewPage } from 'civil-status/utils/transform-upload-new-act';

export default function DocumentBirthUploadNewPage(): React.ReactElement {
  const insert = useHttpClient(
    `${__CIVIL_STATUS_API_URL__}/atti-nascita-sima/caricamento-atto-nascita/inesistente`,
    {
      options: { method: 'POST', loading: true, errorCatching: true },
    }
  );

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues: DocumentBirthUploadFormVM | undefined) => {
      const data = transformUploadBirthNewPage(formValues);
      (
        insert({
          data,
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/stato-civile/nascita');
      });
    },
    [insert, navigate]
  );

  return (
    <>
      <Breadcrumbs items={DocumentCivilStatusBirthUploadCrumbs} base="stato-civile" />
      <FormDocumentBirthUploadNew
        title="Caricamento Nuovo Atto"
        onOk={onSubmit}
        onCancel={() => {
          navigate('/stato-civile/nascita');
        }}
      />
    </>
  );
}

DocumentBirthUploadNewPage.displayName = 'home page component';
